import { Fragment } from 'react'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import InfiniteScroll from 'react-infinite-scroll-component'
import LazyLoad from 'react-lazyload'
import { flatten } from 'lodash-es'

import { useInfiniteArticles } from 'utils/api/hooks'
import ArticleListItem from 'components/common/ArticleListItem'
import { GtmAgent } from 'utils/hooks/analytics'

const Articles = ({ venderId, containerId, venderName }) => {
  const { data, size, setSize } = useInfiniteArticles(() => ({ venderId }))
  const articles = flatten(data)
  const onLoadMore = () => setSize(size + 1)

  const displayedArticles = articles.slice(0, 4)

  const handleArticleClick = (article) => {
    if (!article) return
    GtmAgent.directSendToGTM({
      event: 'living_action',
      living_event_name: 'booking_service_article',
      living_click_name: article?.title,
      living_click_location: '廠商頁',
      living_vender: venderName,
      living_click_article_id: article?._id,
    })
  }

  return (
    // 目前不需滾動功能先註解掉
    // <InfiniteScroll
    //   dataLength={articles?.length || 0}
    //   hasMore={true}
    //   next={onLoadMore}
    //   scrollableTarget={containerId}
    // >
    <Grid container spacing={{ xs: 6, lg: 8 }}>
      {displayedArticles?.map((article) => (
        <Grid item xs={12} lg={6} key={article._id}>
          <LazyLoad
            height={350}
            offset={350}
            scrollContainer={`#${containerId}`}
          >
            <Box onClick={() => handleArticleClick(article)}>
              <ArticleListItem
                key={article._id}
                article={article}
                usedInVenderPage={true}
              />
            </Box>
          </LazyLoad>
          <noscript>
            <style>{`.lazyload-placeholder { display: none; }`}</style>
            <Box onClick={() => handleArticleClick(article)}>
              <ArticleListItem
                key={article._id}
                article={article}
                usedInVenderPage={true}
              />
            </Box>
          </noscript>
        </Grid>
      ))}
    </Grid>
    // </InfiniteScroll>
  )
}

export default Articles
